import { api } from "@";
import { searchValuesPayload } from "./helpers";

// Fetch a paginated list of logs based on search criteria
export const getLogs = (page = 1, pageSize = "", search) => {
  return api.post(
    `/api/Log/search`,
    searchValuesPayload({ ...search, page, pageSize }),
  );
};

// Function to get a list of users
export const getUsers = () => {
  return api.post("/api/AdminUser/users/search-admins", {
    page: 1,
    pageSize: null,
    searchKey: "",
  });
};
